export default "__VITE_ASSET__DdVghciH__"